import { Box } from "../../../../../../mads";
import { NewWindow } from "../../../../../../mads/icons";
import { Text } from "../../../../../../mads/Text";
import { useI18n } from "../../../../../../shared/I18n";
import { TextLink } from "../TextLink/TextLink";

import { Platform, StyleSheet } from "react-native";

// Icon size TextLink renders for a level-3 link (its default level).
const LINK_ICON_SIZE = 16;

// Custom icon component with better alignment
const AlignedNewWindowIcon = (props: any) => (
  <Box sx={styles.iconContainer}>
    <NewWindow {...props} />
  </Box>
);

export function CompanyOverviewLink({
  companyName,
  companyOverviewLink,
  country,
}: {
  companyName?: string;
  companyOverviewLink?: string;
  isSimpleVjImproveActive: boolean;
  country: string;
}) {
  const i18n = useI18n();

  if (!companyOverviewLink) {
    return null;
  }

  if (country !== "JP") {
    return (
      <TextLink
        iconAfter={<AlignedNewWindowIcon />}
        targetUrl={companyOverviewLink}
        variant={"strong"}
        aria-label={`${companyName} (${i18n.gettext("opens in a new tab")})`}
      >
        {companyName}
      </TextLink>
    );
  }

  return (
    <Text level={2}>
      <TextLink targetUrl={companyOverviewLink} variant={"neutral"}>
        {companyName}
      </TextLink>
    </Text>
  );
}

const styles = StyleSheet.create({
  iconContainer: {
    // On native, TextLink shifts `iconAfter` down by `LINK_ICON_SIZE / 6` to
    // bottom-align it, which reads as too low next to the company name. Cancel
    // that push on native only; web is already aligned correctly.
    transform: Platform.select({
      web: undefined,
      default: [{ translateY: -(LINK_ICON_SIZE / 6) }],
    }),
  },
});
